export enum SelectedFilterType {
  AROUND_RADIUS = 'AROUND_RADIUS',
  BRAND = 'BRAND',
  JOB_TITLE = 'JOB_TITLE',
  KEYWORD = 'KEYWORD',
  KNOWLEDGE_DISCIPLINE = 'KNOWLEDGE_DISCIPLINE',
  LANGUAGE = 'LANGUAGE',
  LAST_ACTIVE = 'LAST_ACTIVE',
  LAST_OPEN_TO_OPPORTUNITIES = 'LAST_OPEN_TO_OPPORTUNITIES',
  LOCATION = 'LOCATION',
  OBJECT_ID = 'OBJECT_ID',
  OPEN_TO_TRAVEL = 'OPEN_TO_TRAVEL',
  PAY_RATE_MAX = 'PAY_RATE_MAX',
  PAY_RATE_MIN = 'PAY_RATE_MIN',
  RESPONSIVENESS = 'RESPONSIVENESS',
  SHIFT = 'SHIFT',
  TECHNOLOGY = 'TECHNOLOGY',
  WILLING_TO_RELOCATE = 'WILLING_TO_RELOCATE',
  YEARS_OF_EXPERIENCE = 'YEARS_OF_EXPERIENCE',
}
